import React from 'react'
import { Link } from 'react-router-dom'

const Feature = () => {
  const courses = [
    { name: "Full Stack Development", img: "/full.jpg", path: "/ItCourse/FullStack", },
    { name: "Web Designing", img: "/web1.jpg", path: "/ItCourse/WebDesgin" },
    { name: "UI/UX", img: "/ui.jpg", path: "/ItCourse/UiUx" },
    { name: "Digital Marketing", img: "/digital.jpg", path: "/ItCourse/DigitalMarketing" },
    { name: "Data Science", img: "/data.jpg", path: "/ItCourse/DataScience" },
    { name: "Machine Learning", img: "/ml.webp", path: "/ItCourse/MachineLearning" },
    { name: "Deep Learning", img: "/deep.jpg", path: "/ItCourse/DeepLearning" },
    { name: "Android Development", img: "/Android.jpg", path: "/ItCourse/MobileApplication" },
    { name: "Graphic Designing", img: "/grapic.jpg", path: "/ItCourse/Graphic" },
    { name: "AI", img: "/ai.jpg", path: "/ItCourse/ArtificialIntelligence" },
    { name: "Python", img: "/Python.gif", path: "/ItCourse/Python" },
    { name: "Security", img: "/eth.jpg", path: "/ItCourse/EthicalHacker" },
  ];
  return (
   <>
<section className="py-12 ">
  <div className="max-w-7xl mx-auto px-4 lg-px-6">
    <div className="flex flex-wrap">
      <div className="w-full px-4">
        <div className="text-center mx-auto mb-8  max-w-5xl">
          <span className="font-semibold text-lg text-primary mb-2 block">
          Our IT Services
          </span>
          <h1 className="
            font-bold
            text-3xl
            sm:text-4xl
            text-dark
            
            ">
            What We Offer
          </h1>
          <p className="text-base lg:text-lg text-body-color">
          Helping the next generation of tech experts gain the latest skills and knowledge.
          </p>
        </div>
      </div>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
  {courses.map((course, index) => (
    <div key={index} className="relative rounded overflow-hidden group">
      <Link to={course.path}>
        {/* Image with hover effect */}
        <img
          src={course.img}
          alt={course.name}
          className="w-full h-52 transform transition-transform duration-300 group-hover:scale-110"
        />
        {/* Name positioned at the bottom */}
        <p className="absolute bottom-0 left-0 w-full bg-black bg-opacity-50 text-white text-lg font-medium py-2 text-center">
          {course.name}
        </p>
      </Link>
    </div>
  ))}
</div>



  </div>
</section>


   </>
  )
}

export default Feature
